import React from 'react';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import { Button } from '../components/ui/button';

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
);

const Login = () => {
  const { startGoogleLogin, loading, user, error } = useAuth();

  React.useEffect(() => {
    if (!loading && user) {
      window.location.replace('/deals');
    }
  }, [loading, user]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-lilac-100 via-white to-mint-100 p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8">
        <div className="flex flex-col items-center gap-2 mb-6">
          <Logo size="lg" />
          <p className="text-sm text-slate-500">manage your roster like never before</p>
        </div>

        <Button onClick={startGoogleLogin} className="w-full h-11 bg-white hover:bg-slate-50 text-slate-800 border border-slate-200 font-medium gap-2">
          <GoogleIcon /> Continue with Google
        </Button>

        {error && (
          <div className="mt-4 text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</div>
        )}

        <p className="text-xs text-slate-400 text-center mt-6">
          managers sign in first. talent must be added to the roster by an admin before they can sign in.
        </p>
      </div>
    </div>
  );
};

export default Login;
